import axios from 'axios';
import {BASE_BACKEND_URL} from "@/services/config";

const httpClient = axios.create({
    baseURL: BASE_BACKEND_URL,
    withCredentials: true,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

export default httpClient;
